import { styled } from "@mui/material";
import { pxToRem } from "../../utils/fontSizeUtility";

export const CodeBlock = styled("code")(({ theme }) => ({
  fontWeight: 700,
  fontSize: "15px",
  lineHeight: "23px",
  color: theme.palette.text.secondary,
  paddingTop: pxToRem(3),
  paddingRight: pxToRem(8),
  paddingBottom: pxToRem(2),
  paddingLeft: pxToRem(8),
  backgroundColor: theme.palette.background.default,
  border: "1px solid",
  borderColor: theme.palette.divider,
  borderRadius: "2px",
}));
